var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"login-box-left"}),_c('keep-alive',[_c('router-view')],1)],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beian-box"},[_vm._v(" 备案号: "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("蜀ICP备2021006184号")])])
}]

export { render, staticRenderFns }